// import { useRef, useState } from "react";
// import { useTimer } from "react-timer-hook";
// import { Box, Button, TextField } from "@mui/material";
// import ModalComponent from "../Modals/ModelComponent";

// export default function TimerButton() {
//   const lastRightClickTime = useRef(0);
//   const DEFAULT_MINUTES = 0;
//   const [initialMinutes, setInitialMinutes] = useState(DEFAULT_MINUTES); // current set time
//   const [defaultMinutes] = useState(DEFAULT_MINUTES); // original default time
//   const [openModal, setOpenModal] = useState(false);
//   const [newTimeMinutes, setNewTimeMinutes] = useState(initialMinutes);

//   // Setup initial expiry time
//   const getExpiry = (minutes) => {
//     const time = new Date();
//     time.setSeconds(time.getSeconds() + minutes * 60);
//     return time;
//   };

//   const { seconds, minutes, restart } = useTimer({
//     expiryTimestamp: getExpiry(initialMinutes),
//     onExpire: () => {
//       console.warn("Timer expired");
//     },
//   });

//   // Format time mm:ss
//   const formatTime = (m, s) => `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;

//   // Reset to current configured time
//   const handleReset = () => {
//     restart(getExpiry(initialMinutes));
//   };

//   // Save new timer duration
//   const handleSave = () => {
//     setInitialMinutes(newTimeMinutes);
//     restart(getExpiry(newTimeMinutes));
//     setOpenModal(false);
//   };

//   // Reset to default 5 min
//   const handleResetToDefault = () => {
//     setInitialMinutes(defaultMinutes);
//     restart(getExpiry(defaultMinutes));
//     setOpenModal(false);
//   };

//   const isExpired = minutes === 0 && seconds === 0;

//   const handleRightDoubleClick = (e) => {
//     e.preventDefault(); // prevent browser menu
//     const now = Date.now();
//     if (now - lastRightClickTime.current < 300) {
//       // double right click detected (300ms threshold)
//       setNewTimeMinutes(initialMinutes);
//       setOpenModal(true);
//     }
//     lastRightClickTime.current = now;
//   };
//   return (
//     <>
//       {/* Timer UI */}
//       <Box
//         onClick={handleReset}
//         onContextMenu={handleRightDoubleClick}
//         sx={{
//           width: 64,
//           height: 64,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontWeight: "bold",
//           fontSize: "14px",
//           borderRadius: "8px",
//           cursor: "pointer",
//           backgroundColor: isExpired ? "#ff0000" : "#1976d2",
//           color: "white",
//           animation: isExpired ? "blinker 1s linear infinite" : "none",
//           "@keyframes blinker": {
//             "30%": { opacity: 0.01 },
//           },
//         }}
//       >
//         {formatTime(minutes, seconds)}
//       </Box>

//       {/* Modal */}
//       {/* <ModalComponent
//         open={openModal}
//         handleClose={() => setOpenModal(false)}
//         headerText="Set Timer Duration"
//         bodyComponent={
//           <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//             <TextField label="Minutes" type="number" value={newTimeMinutes} onChange={(e) => setNewTimeMinutes(Number(e.target.value))} />
//             <Box sx={{ display: "flex", gap: 2 }}>
//               <Button variant="contained" onClick={handleSave}>
//                 Save
//               </Button>
//               <Button variant="outlined" onClick={handleResetToDefault}>
//                 Reset to Default
//               </Button>
//               <Button variant="text" onClick={() => setOpenModal(false)}>
//                 Cancel
//               </Button>
//             </Box>
//           </Box>
//         }
//       /> */}
//       <ModalComponent
//         open={openModal}
//         handleClose={() => setOpenModal(false)}
//         headerText="Set Timer Duration"
//         bodyComponent={
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               gap: 3,
//               minWidth: 300,
//               p: 2,
//             }}
//           >
//             <TextField
//               label="Minutes"
//               type="number"
//               value={newTimeMinutes}
//               onChange={(e) => setNewTimeMinutes(Number(e.target.value))}
//               fullWidth
//               sx={{
//                 "& .MuiInputBase-root": {
//                   fontSize: "16px",
//                 },
//               }}
//             />
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 gap: 2,
//                 width: "100%",
//               }}
//             >
//               <Button variant="contained" color="primary" onClick={handleSave} sx={{ minWidth: 100 }}>
//                 Save
//               </Button>
//               <Button variant="outlined" onClick={handleResetToDefault} sx={{ minWidth: 140 }}>
//                 Reset to Default
//               </Button>
//               <Button variant="text" onClick={() => setOpenModal(false)} sx={{ minWidth: 80 }}>
//                 Cancel
//               </Button>
//             </Box>
//           </Box>
//         }
//       />
//     </>
//   );
// }
import { useEffect, useRef, useState } from "react";
import { useTimer } from "react-timer-hook";
import { Box, Button, TextField } from "@mui/material";
import ModalComponent from "../Modals/ModelComponent";

export default function TimerButton() {
  const lastRightClickTime = useRef(0);
  const LOCAL_STORAGE_KEY = "timerMinutes";

  // Fetch from localStorage or set to 5
  const getInitialMinutes = () => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    const n = Number(stored);
    return stored !== null && Number.isFinite(n) && n >= 0 ? n : 5;
  };

  // Clamp any candidate minutes to a non-negative finite number
  const clampMinutes = (value) => {
    const n = Number(value);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  };

  const [initialMinutes, setInitialMinutes] = useState(getInitialMinutes);
  const [newTimeMinutes, setNewTimeMinutes] = useState(initialMinutes);
  const [openModal, setOpenModal] = useState(false);

  // Update localStorage whenever initialMinutes changes
  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, initialMinutes);
  }, [initialMinutes]);

  // Setup expiry time
  const getExpiry = (minutes) => {
    const time = new Date();
    time.setSeconds(time.getSeconds() + minutes * 60);
    return time;
  };

  const { seconds, minutes, restart } = useTimer({
    expiryTimestamp: getExpiry(initialMinutes),
    onExpire: () => {
      console.warn("Timer expired");
    },
  });

  const formatTime = (m, s) => `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;

  const handleReset = () => {
    restart(getExpiry(initialMinutes));
  };

  const handleSave = () => {
    const safeMinutes = clampMinutes(newTimeMinutes);
    setInitialMinutes(safeMinutes);
    restart(getExpiry(safeMinutes));
    setOpenModal(false);
  };

  const handleResetToDefault = () => {
    setInitialMinutes(5); // default 5 min
    restart(getExpiry(5));
    setOpenModal(false);
  };

  const isExpired = minutes === 0 && seconds === 0;

  const handleRightDoubleClick = (e) => {
    e.preventDefault();
    const now = Date.now();
    if (now - lastRightClickTime.current < 300) {
      setNewTimeMinutes(initialMinutes);
      setOpenModal(true);
    }
    lastRightClickTime.current = now;
  };

  return (
    <>
      {/* Timer UI */}
      <Box
        onClick={handleReset}
        onContextMenu={handleRightDoubleClick}
        sx={{
          width: 64,
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          fontSize: "14px",
          borderRadius: "8px",
          cursor: "pointer",
          backgroundColor: isExpired ? "#ff0000" : "#1976d2",
          color: "white",
          animation: isExpired ? "blinker 1s linear infinite" : "none",
          "@keyframes blinker": {
            "30%": { opacity: 0.01 },
          },
        }}
      >
        {formatTime(minutes, seconds)}
      </Box>

      {/* Modal */}
      <ModalComponent
        open={openModal}
        handleClose={() => setOpenModal(false)}
        headerText="Set Timer Duration"
        bodyComponent={
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 3,
              minWidth: 300,
              p: 2,
            }}
          >
            <TextField
              label="Minutes"
              type="number"
              value={newTimeMinutes}
              onChange={(e) => setNewTimeMinutes(clampMinutes(e.target.value))}
              fullWidth
              sx={{
                "& .MuiInputBase-root": {
                  fontSize: "16px",
                },
              }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                width: "100%",
              }}
            >
              <Button variant="contained" color="primary" onClick={handleSave} sx={{ minWidth: 100 }}>
                Save
              </Button>
              <Button variant="outlined" onClick={handleResetToDefault} sx={{ minWidth: 140 }}>
                Reset to Default
              </Button>
              <Button variant="text" onClick={() => setOpenModal(false)} sx={{ minWidth: 80 }}>
                Cancel
              </Button>
            </Box>
          </Box>
        }
      />
    </>
  );
}
